import React, { useEffect } from 'react';
import { useOktaAuth } from '@okta/okta-react';
import { Outlet, useNavigate } from 'react-router-dom';

function RequireAuth() {
  const { oktaAuth, authState } = useOktaAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!authState) {
      return;
    }

    if (!authState.isAuthenticated) {
      navigate('/login');
    }
  }, [authState, navigate]);

  if (!authState || !authState.isAuthenticated) {
    return <div>Loading...</div>;
  }

  return <Outlet />;
}

export default RequireAuth;
